import script from "./TeacherForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherForm.vue?vue&type=script&setup=true&lang=js"

import "./TeacherForm.vue?vue&type=style&index=0&id=3ee1dc1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ee1dc1c"]])

export default __exports__